module.exports = __webpack_public_path__ + "static/media/cash.9ee087d7.svg";